module.exports = "div {\n  display: inline-block;\n  margin-left: 3px; }\n\na, p {\n  text-transform: capitalize; }\n\n#total {\n  padding: 0px 5px;\n  margin: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-search-view-btns/app-search-view-btns.component.scss
// module id = 1164
// module chunks = 1